import { configureClientAnalytics } from "./configureClientAnalytics.mjs";
import { configureContextSwitchHooks } from "./configureContextSwitchHooks.mjs";
import { configureEntryTimestampsGetter } from "./configureEntryTimestampsGetter.mjs";
import { configureExchangeRates } from "./configureExchangeRates.mjs";
import { configureExternalABTests } from "./configureExternalABTests.mjs";
import { configureGeolocation } from "./configureGeolocation.mjs";
import { configureLatestChatbotAnalytics } from "./configureLatestChatbotAnalytics.mjs";
import { configureLineChatbotSubscriptionCheck } from "./configureLineChatbotSubscriptionCheck.mjs";
import { configureLineFriendCountDebugAnalytics } from "./configureLineFriendCountDebugAnalytics.mjs";
import { configurePayloadEncoder } from "./configurePayloadEncoder.mjs";
import { configureStorageAdapter } from "./configureStorageAdapter.mjs";
import { configureTelegramAdEntryReply } from "./configureTelegramAdEntryReply.mjs";
import { configureTelegramPlayerPhoto } from "./configureTelegramPlayerPhoto.mjs";
import { configureTime } from "./configureTime.mjs";
import { configureWebPushSubscriptionHook } from "./configureWebPushSubscriptionHook.mjs";
function configureExtensions(opts) {
  configureExchangeRates(opts);
  configureGeolocation(opts);
  configurePayloadEncoder(opts);
  configureStorageAdapter(opts);
  configureTime(opts);
  if (opts.gcinstant.platformID === "fb") {
    configureContextSwitchHooks(opts);
  }
  if (opts.gcinstant.platformID === "line" || opts.gcinstant.platformID === "web") {
    configureLineChatbotSubscriptionCheck(opts);
  }
  if (opts.gcinstant.platformID === "line") {
    configureLineFriendCountDebugAnalytics(opts);
  }
  if (opts.gcinstant.platformID === "web") {
    configureWebPushSubscriptionHook(opts);
  }
  if (opts.gcinstant.platformID === "telegram") {
    configureTelegramPlayerPhoto(opts);
    configureTelegramAdEntryReply(opts);
  }
  configureEntryTimestampsGetter(opts);
  configureLatestChatbotAnalytics(opts);
  configureExternalABTests(opts);
  void configureClientAnalytics(opts);
}
export {
  configureExtensions
};
